import React, { useState, useEffect, useRef } from "react";
import { Button, TextField, Grid, Tooltip, IconButton, CircularProgress } from "@mui/material";
import GetAppIcon from "@mui/icons-material/GetApp";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";
import axios from "../../../../axios-order";
import moment from "moment";

import DatePicker from './DatePicker';
import { ValidatorForm } from "react-material-ui-form-validator";
import BoxWrapper from "../../../../components/ui/boxWrapper";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

const apiUrl = process.env.REACT_APP_BACKEND_BASE_URL;

export default function IMSRepository() {
    const [fileDataToUpload, setFileDataToUpload] = useState("");
    const [showSuccessOnly, setShowSuccessOnly] = useState(false);
    const history = useHistory();

    const [colorForErrorMessage, setColorForErrorMessage] = useState("red");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageVisibilityStyle, setErrorMessageVisibilityStyle] =
        useState("hidden");
    const [errorMessageDisplayStyle, setErrorMessageDisplayStyle] =
        useState("none");

    const [recordForTable, setRecordForTable] = useState([]);
    const [recordForTableSearch, setRecordForTableSearch] = useState([]);

    const [loaderForTable, setLoaderForTable] = useState(false);

    const [fromMonthYearDisplay, setFromMonthYearDisplay] = useState(null)
    const [fromToYearDisplay, setFromToYearDisplay] = useState(null)
    const [next, setNext] = useState(false)
    const [responseMessage, setResponseMessage] = useState("");

    const [status, setStatus] = useState(false);
    const [data, setData] = useState([]);

    const [errorMessages, setErrorMessages] = useState('');
    const [showBoxWrapper, setShowBoxWrapper] = useState(false);
    const [responseData, setResponseData] = useState("");
    const [displayResponse, setDisplayResponse] = useState(false);
    const [taskId, setTaskId] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");
    const [businessEntityId, setBusinessEntityId] = useState(localStorage.getItem("business_entity_id"));
    const fileInputRef = useRef(null);
    const [fileName, setFileName] = useState("");
    const [downloadingId, setDownloadingId] = useState(null);
    const [selectedRemark, setSelectedRemark] = useState('');

    useEffect(() => {
        if (taskId) {
            const additionalApiUrl = `/autodownloadapi/${taskId}`;
            axios.get(additionalApiUrl)
                .then(response => {
                    console.log('Additional API response:', response.data);
                })
                .catch(error => {
                    console.error('Error calling additional API:', error);
                });
        }
    }, [taskId]);

    const handleButtonClick = () => {
        setShowBoxWrapper(!showBoxWrapper);
    };

    const handleBackNavigation = () => {
        history.push("/repoCards");
    };

    const handleSnackbarOpen = (message, severity) => {
        setSelectedRemark("");
        setSnackbarOpen(true);
        setSnackbarSeverity(severity);
        setResponseMessage(message);
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
        setResponseMessage("");
    };

    const handleDownload = (gst_task_id, business_entity_id) => {
        const url = `${apiUrl}/mydemo/gstDownload/gstrtaskdownload/`;
        const requestData = new FormData();
        requestData.append('task_id', gst_task_id);
        requestData.append('entity_id', business_entity_id);

        axios.post(url, requestData)
            .then(response => {
                console.log('API response:', response.data);
                setResponseData(response.data)
                setDisplayResponse(true);
                const autoTaskId = extractAutoTaskId(response.data);
                if (autoTaskId) {
                    setTaskId(autoTaskId);
                }

                setTimeout(() => {
                    setResponseData('');
                    setDisplayResponse(false);
                }, 10000);
            })
            .catch(error => {
                console.error('Error sending data:', error);
            });
    };

    const extractAutoTaskId = (response) => {
        const autoTaskIdPattern = /Auto Task id :(\d+)/;
        const match = response.match(autoTaskIdPattern);
        return match ? match[1] : null;
    };

    const business_entity_id = localStorage.getItem('business_entity_id');

    const handleClick = (first_col, second_col) => {
        axios.post(`${apiUrl}/table/`, { first_col, second_col })
            .then(response => {
                console.log('Data sent to backend:', response.data);
            })
            .catch(error => {
                console.error('Error sending data:', error);
            });
    };

    const v = {
        upload_status: true,
        upload_fail_reason: 'Upload failed due to an error.',
    };

    const submitEvent = () => {
        axios
            .post(`/ims_auto_download`, {
                business_entity_id: localStorage.getItem("business_entity_id"),
            })
            .then((response) => {
                console.log("Data sent to backend:", response.data);
                if (response.data.status === "error") {
                    handleSnackbarOpen(response.data.message, "error");
                } else {
                    handleSnackbarOpen(response.data.message, "success");
                }
            })
            .catch((error) => {
                console.error("Error sending data:", error);
                const errorMessage =
                    error.response?.data?.message || "An unexpected error occurred.";
                handleSnackbarOpen(errorMessage, "error");
            });
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setResponseMessage("");
        }, 7000);
        return () => clearTimeout(timer);
    }, [responseMessage]);

    const handleImsDownload = () => {
        setIsSubmitting(true);
        const url = `${apiUrl}/mydemo/gstDownload/gstr2bdownload/`;
        const entity_id = localStorage.getItem('business_entity_id');
        const fromRetPeriod = fromMonthYearDisplay ? moment(fromMonthYearDisplay).format('MMYYYY') : '';
        const toRetPeriod = fromMonthYearDisplay ? moment(fromMonthYearDisplay).format('MMYYYY') : '';

        const formData = new FormData();
        formData.append('entity_id', entity_id);
        formData.append('fromRetPeriod', fromMonthYearDisplay);
        formData.append('toRetPeriod', fromMonthYearDisplay);

        axios.post(url, formData)
            .then(response => {
                try {
                    const responseData = response.data;
                    if (responseData.message_type && responseData.message) {
                        handleSnackbarOpen(
                            responseData.message,
                            responseData.message_type
                        );
                    } else {
                        handleSnackbarOpen('An unexpected response was received.', 'error');
                    }
                } catch (error) {
                    console.log(error);
                    handleSnackbarOpen('Unexpected Error.', 'error');
                }
            })
            .catch(error => {
                console.log(error);
                handleSnackbarOpen('Unexpected Error.', 'error');
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    };

    const fileUploadCancelButtonHandler = () => {
        functionForSuccesfullMessageAndErroeMessage("", "hidden", "none", "");
        setFileDataToUpload("");
        setFileName("");
    };

    const handleSearch = (e) => {
        let Search = e.target.value.trim();
        const searchName = recordForTableSearch.filter((v) => {
            return (
                String(v.gstr_upload_file_type)
                    .toLowerCase()
                    .indexOf(Search.toLowerCase()) >= 0 ||
                String(v.financial_year).toLowerCase().indexOf(Search.toLowerCase()) >=
                0 ||
                String(v.generation_date).toLowerCase().indexOf(Search.toLowerCase()) >=
                0 ||
                String(moment(v.tax_period, "MMYYYY").format("MM-YYYY")).indexOf(
                    Search
                ) >= 0 ||
                String(
                    moment(v.upload_date, "YYYY-MM-DD").format("DD-MM-YYYY")
                ).indexOf(Search) >= 0
            );
        });
        setRecordForTable(searchName);
    };

    const functionForSuccesfullMessageAndErroeMessage = (
        color,
        visible,
        display,
        message
    ) => {
        setColorForErrorMessage(color);
        setErrorMessageVisibilityStyle(visible);
        setErrorMessageDisplayStyle(display);
        setErrorMessage(message);
    };

    const handleFileUpload = (e) => {
        functionForSuccesfullMessageAndErroeMessage("", "hidden", "none", "");
        if (e.target.files.length) {
            const file_data = e.target.files[0];
            let fileName = file_data.name;
            setFileName(fileName);
            const reader = new FileReader();
            reader.readAsDataURL(file_data);
            reader.onload = function () {
                let file_value = reader.result;
                setFileDataToUpload(file_value);
            };
            e.target.value = null;
        }
    };

    const handleSubmitEvent = (e) => {
        functionForSuccesfullMessageAndErroeMessage(
            "green",
            "visible",
            "block",
            "Uploading file Please Wait..."
        );
        if (fileName === "") {
            functionForSuccesfullMessageAndErroeMessage(
                "red",
                "visible",
                "block",
                "Please Upload The File!"
            );
        } else {
            const business_entity_id = localStorage.getItem('business_entity_id');
            axios
                .post(`/ims_manual_download`, {
                    file: fileDataToUpload,
                    document_name: fileName,
                    business_entity_id: localStorage.getItem('business_entity_id')
                })
                .then((res) => {
                    if (res.data.status === true) {
                        functionForSuccesfullMessageAndErroeMessage("", "hidden", "none", "");
                        getApiImsRepository();
                        resetFileUpload();
                    } else {
                        functionForSuccesfullMessageAndErroeMessage(
                            "red",
                            "visible",
                            "block",
                            res.data.Message
                        );
                        resetFileUpload();
                    }
                })
                .catch((error) => {
                    functionForSuccesfullMessageAndErroeMessage(
                        "red",
                        "visible",
                        "block",
                        error.response.data.Message
                    );
                    resetFileUpload();
                });
        }
    };

    const resetFileUpload = () => {
        setFileDataToUpload(null);
        setFileName('');
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    };

    const getApiImsRepository = () => {
        setLoaderForTable(true);
        axios
            .get(`/ims_repo_summary/${businessEntityId}`)
            .then((res) => {
                if (res.data.status === true) {
                    setLoaderForTable(false);
                    setRecordForTable(res.data.data);
                    setRecordForTableSearch(res.data.data);
                } else {
                    setLoaderForTable(false);
                    alert(res.data.message);
                }
            })
            .catch(() => setLoaderForTable(false));
    };

    useEffect(() => {
        getApiImsRepository();
    }, []);

    const filteredRecords = recordForTable?.filter(
        (v) =>
            !(v.upload_status === "Failed" && v.upload_fail_reason === "Latest Data Already Present")
    );

    const handleRemarkClick = (remark, status) => {
        setSelectedRemark(remark || 'No remark available');
        setSnackbarSeverity(status === "Fail" || status === "FAILED" ? "error" : "success");
        setSnackbarOpen(true);
    };

    const saveBlob = (blob, fileName) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

    const handleRepositoryDownload = async (summary_id) => {
        const entityId = localStorage.getItem("business_entity_id");
        setDownloadingId(summary_id);

        try {
            const res = await axios.get(
                `/ims_repository_download/${entityId}/${summary_id}`,
                { responseType: "blob" }
            );

            const contentType = res.headers?.["content-type"] || "";

            // Case 1: backend returned JSON (base64 file or an error message)
            if (contentType.includes("application/json")) {
                const json = JSON.parse(await res.data.text());

                if ((json.status === "pass" || json.status === true) && json.file) {
                    const link = document.createElement("a");
                    link.href = `data:application/octet-stream;base64,${json.file}`;
                    link.download = json.file_name || `IMS_Repository_${summary_id}.xlsx`;
                    link.click();
                } else {
                    handleSnackbarOpen(json.message || "Unable to download!", "error");
                }
                return;
            }

            // Case 2: backend streamed the file directly
            const disposition = res.headers?.["content-disposition"] || "";
            const match = disposition.match(/filename="?([^"]+)"?/);
            saveBlob(res.data, match ? match[1] : `IMS_Repository_${summary_id}.xlsx`);
        } catch (error) {
            let message = "Server Error, Try After Some Time";
            try {
                const errJson = JSON.parse(await error.response?.data?.text());
                message = errJson.message || message;
            } catch (e) { /* not JSON, keep default */ }
            handleSnackbarOpen(message, "error");
        } finally {
            setDownloadingId(null);
        }
    };

    return (
        <React.Fragment>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "10px 0",
                }}
            >
                <button
                    className="button-primary"
                    onClick={submitEvent}
                    style={{
                        height: "40px",
                    }}
                >
                    IMS Auto Download
                </button>

                <Tooltip title="Back" arrow>
                    <IconButton
                        onClick={handleBackNavigation}
                        sx={{
                            borderRadius: '50%',
                            padding: '6px',
                            color: '#263238',
                            fontSize: '20px',
                            backgroundColor: '#ffffff',
                            height: '36px',
                            width: '36px',
                            '&:hover': {
                                backgroundColor: '#455a64',
                                color: '#ffffff',
                            },
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                            transition: 'background-color 0.3s ease',
                        }}
                    >
                        <ArrowBackIcon sx={{ fontSize: '20px' }} />
                    </IconButton>
                </Tooltip>
            </div>


            {/* Upload IMS Return – ALWAYS VISIBLE */}
            <BoxWrapper boxTitle="Upload IMS Repository">
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                            }}
                        >
                            <label className="button-primary" style={{ cursor: "pointer" }}>
                                Upload
                                <input
                                    ref={fileInputRef}
                                    type="file"
                            accept=".xlsx, .json, .zip"
                                    onChange={handleFileUpload}
                                    hidden
                                />
                            </label>

                            <div>
                                <TextField
                                    value={fileName}
                                    variant="standard"
                                    style={{ width: "350px", paddingLeft: "10px" }}
                                    placeholder="No Data Have Uploaded"
                            inputProps={{ readOnly: true }}
                                />
                            </div>

                            <div>
                                <button
                                    className="button-primary"
                                    style={{ marginLeft: "10px" }}
                                    onClick={handleSubmitEvent}
                                >
                                    Submit
                                </button>

                                <button
                                    className="button-outlined-secondary"
                                    onClick={fileUploadCancelButtonHandler}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>

                        <div
                            style={{
                                color: colorForErrorMessage,
                                padding: "5px",
                                fontWeight: "600",
                                visibility: errorMessageVisibilityStyle,
                                display: errorMessageDisplayStyle,
                            }}
                        >
                            {errorMessage}
                        </div>
                    </BoxWrapper>

            {/* IMS Inward Repository */}
            <BoxWrapper
                boxTitle="IMS Inward Repository"
                enableSearchInput={true}
                searchInputPlaceholder="Search..."
                searchInputOnchange={handleSearch}
                enableAddButton={true}
                addButtonLabel="Refresh"
                addButtonHandlerFn={getApiImsRepository}
            >
                <div className="responsive-table">
                    <table className="custome-table">
                        <thead>
                            <tr>
                                <th>IMS File Type</th>
                                <th>Uploaded Time</th>
                                <th>Status</th>
                                <th>Remark</th>
                                <th>Download</th>
                            </tr>
                        </thead>
                        <tbody>
                            {recordForTable?.map((v) => (
                                <tr key={v.summary_id}>
                                        <td>{v.ims_file_type}</td>
                                        <td>{v.uploaded_datetime}</td>
                                        <td>{v.status}</td>
                                        <td>
                                            <VisibilityOutlinedIcon
                                                className="action-icon-button showIcon"
                                            onClick={() =>
                                                handleRemarkClick(v.remarks, v.status)
                                            }
                                            />
                                        </td>
                                    <td>
                                        {downloadingId === v.summary_id ? (
                                            <CircularProgress size={20} style={{ color: "#64adf7" }} />
                                        ) : (
                                            <Tooltip title="Download" arrow>
                                                <GetAppIcon
                                                    className="action-icon-button showIcon"
                                                    onClick={() => handleRepositoryDownload(v.summary_id)}
                                                />
                                            </Tooltip>
                                        )}
                                    </td>
                                    </tr>
                            ))}

                            {loaderForTable ? (
                                <tr>
                                    <td colSpan={5} style={{ textAlign: "center" }}>
                                        Loading…Please wait
                                    </td>
                                </tr>
                            ) : recordForTable?.length === 0 ? (
                                <tr>
                                    <td colSpan={5} style={{ color: "red", textAlign: "center" }}>
                                        No Data Found!
                                    </td>
                                </tr>
                            ) : null}
                        </tbody>
                    </table>
                </div>
            </BoxWrapper>

            {/* Snackbar */}
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                open={snackbarOpen}
                autoHideDuration={5000}
                onClose={handleSnackbarClose}
                style={{ maxWidth: "25%" }}
            >
                <MuiAlert
                    elevation={2}
                    variant="filled"
                    onClose={handleSnackbarClose}
                    severity={snackbarSeverity}
                >
                    {selectedRemark || responseMessage}
                </MuiAlert>
            </Snackbar>

        </React.Fragment>
    );
}